module.exports = __webpack_public_path__ + "static/ganesha404-88bc8f7397aa747183cae3a283471d24.gif";